<script lang="ts">
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import CustomButton from "@/components/global/styledComponents/customButton.vue";
import { IDialog } from "@/store/dialog";
import { dialogModule } from "@/store/modules/dialogModule/dialogModule";

//* Component definition ************************************************************

@Component({
  name: "Dialog",
  components: { CustomButton },
})

//* Class ***************************************************************************
export default class Dialog extends Vue {
  @Prop({}) dialog: IDialog;

  public buttonEnabled: boolean = false;

  mounted() {
    let vm = this;
    if (this.dialog.actionButtonDelay != 0) {
      this.buttonEnabled = false;

      setTimeout(function () {
        vm.buttonEnabled = true;
      }, vm.dialog.actionButtonDelay * 1000);
    } else {
      this.buttonEnabled = true;
    }
  }

  closeNormalDialog() {
    dialogModule.closeNormalDialog(true);
  }
  closeNormalDialogCancel() {
    dialogModule.closeNormalDialog(false);
  }

  get isPng() {
    return this.dialog.icon.includes(".png");
  }
}
</script>

<template>
  <v-card>
    <v-card-title>
      <v-icon v-if="dialog.type === 0">
        info
      </v-icon>
      <v-icon v-if="dialog.type === 1">
        help
      </v-icon>

      <span class="title font-weight-light">{{ dialog.header }}</span>
    </v-card-title>
    <v-card-text v-if="dialog.html === false">
      {{ dialog.text }}
    </v-card-text>
    <v-card-text
      v-if="dialog.html === true"
      v-html="dialog.text"
    />

    <div v-if="dialog.type === 0">
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="!buttonEnabled"
          data-cy="dialog-ok-btn"
          @click="closeNormalDialog"
        >
          Ok
        </v-btn>
      </v-card-actions>
    </div>
    <div v-if="dialog.type === 1">
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="!buttonEnabled"
          data-cy="dialog-cancel-btn"
          @click="closeNormalDialogCancel"
        >
          {{ $t($ts.dialog.cancel) }}
        </v-btn>
        <v-btn
          color="success"
          :disabled="!buttonEnabled"
          data-cy="dialog-confirm-btn"
          @click="closeNormalDialog"
        >
          {{ $t($ts.dialog.confirm) }}
        </v-btn>
      </v-card-actions>
    </div>
    <div v-if="dialog.type === 2">
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="!buttonEnabled"
          data-cy="dialog-no-btn"
          @click="closeNormalDialogCancel"
        >
          {{ $t($ts.dialog.no) }}
        </v-btn>
        <v-btn
          color="success"
          :disabled="!buttonEnabled"
          data-cy="dialog-yes-btn"
          @click="closeNormalDialog"
        >
          {{ $t($ts.dialog.yes) }}
        </v-btn>
      </v-card-actions>
    </div>
  </v-card>
</template>

<style scoped>
button {
  margin: 0 5px;
}
</style>
